import { audioContext } from '../audioContext';

export class MultisamplerNode {
   constructor(presetData, note) {
      const source = presetData.sources[presetData.sourcesMap[note]];
      this.detuneOffset = source.noteValue * -100;
      this.sample = audioContext.createBufferSource();
      this.sample.buffer = source.buffer;
      this.sample.detune.setValueAtTime(
         note * 100 + this.detuneOffset,
         audioContext.currentTime
      );

      this.gainNode = audioContext.createGain();

      this.sample.connect(this.gainNode);
      this.sample.onended = () => {
         if (this.onended) this.onended();
         this.gainNode.disconnect();
      };

      this.stopInitiatedTime = null;
   }

   start(...args) {
      return this.sample.start(...args);
   }

   stop(time) {
      const stopTime = time || audioContext.currentTime + 0.02;
      const nextStopInitiatedTime = stopTime - 0.02;

      if (
         this.stopInitiatedTime != null &&
         nextStopInitiatedTime < this.stopInitiatedTime
      ) {
         this.gainNode.gain.cancelScheduledValues(nextStopInitiatedTime);
      }

      if (
         this.stopInitiatedTime == null ||
         nextStopInitiatedTime < this.stopInitiatedTime
      ) {
         this.gainNode.gain.setValueAtTime(1, nextStopInitiatedTime);
         this.gainNode.gain.exponentialRampToValueAtTime(0.00001, stopTime);
         this.sample.stop(stopTime);
         this.stopInitiatedTime = nextStopInitiatedTime;
      }
   }

   connect(...args) {
      this.gainNode.connect(...args);
   }
}
